var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isNullOrUndefined } from '@syncfusion/ej2-base';
var EVENT_GET_TOOLS = 'getWebMcpTools';
var EVENT_REGISTER_TOOLS = 'registerWebMcpTools';
var EVENT_BEFORE_EXECUTE = 'beforeWebMcpToolExecute';
// 🟠 Component-specific WebMCP tool definitions
// These tool schemas match the generated tool spec in webmcptoolconfirmation.md.
var webMcpTools = [
    {
        name: 'getProjectTasks',
        description: 'Returns the current project task set from the Gantt after the latest view state is applied.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: {
            type: 'object',
            properties: {
                tasks: { type: 'array', items: { type: 'object' } }
            },
            required: ['tasks']
        }
    },
    {
        name: 'getTaskDetails',
        description: 'Retrieves scheduling/geometry details and derived flags for a specific task.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: 'string' }
            },
            required: ['taskId']
        },
        outputSchema: {
            type: 'object',
            properties: {
                taskInfo: { type: 'object' }
            },
            required: ['taskInfo']
        }
    },
    {
        name: 'manageHierarchy',
        description: 'Controls hierarchy expansion/collapse state to prepare deterministic task extraction and reporting.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['expandAll', 'collapseAll', 'expandByID', 'expandByIndex'] },
                id: { type: ['number', 'string'] },
                index: {
                    anyOf: [
                        { type: 'number' },
                        { type: 'array', items: { type: 'number' } }
                    ]
                }
            },
            required: ['action']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'getCriticalTasks',
        description: 'Returns tasks flagged as critical when critical path is enabled.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: {
            type: 'object',
            properties: {
                criticalTasks: { type: 'array', items: { type: 'object' } }
            },
            required: ['criticalTasks']
        }
    },
    {
        name: 'createTask',
        description: 'Creates one or more new tasks (optionally positioned within the hierarchy).',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                data: { type: 'object' },
                rowPosition: { type: 'string' },
                rowIndex: { type: 'number' }
            },
            required: ['data']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'updateTask',
        description: 'Applies updates to a specific task record based on a record payload.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                data: { type: 'object' }
            },
            required: ['data']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'deleteTask',
        description: 'Deletes one or more tasks by id/index/record selection.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskDetail: {
                    anyOf: [
                        { type: 'number' },
                        { type: 'string' },
                        { type: 'array', items: { type: 'number' } },
                        { type: 'array', items: { type: 'string' } },
                        { type: 'object' },
                        { type: 'array', items: { type: 'object' } } // IGanttData[]
                    ]
                }
            },
            required: ['taskDetail']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'splitTask',
        description: 'Splits a task into multiple segments at one or more split dates.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] },
                splitDate: {}
            },
            required: ['taskId', 'splitDate']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'manageTaskDependencies',
        description: 'Adds, updates, or removes predecessor dependencies for a task.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] },
                operation: { type: 'string', enum: ['add', 'update', 'remove'] },
                predecessorString: { type: 'string' }
            },
            required: ['taskId', 'operation']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'updateProjectDates',
        description: 'Updates project start/end dates and applies timeline rounding rules.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                startDate: { type: 'string' },
                endDate: { type: 'string' },
                isTimelineRoundOff: { type: 'boolean' },
                isFrom: { type: 'string' }
            },
            required: ['startDate', 'endDate', 'isTimelineRoundOff']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'getVisibleTasksHierarchy',
        description: 'Computes the visible/expanded task set for a hierarchy without requiring UI navigation.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                records: { type: 'array', items: { type: 'object' } }
            },
            required: []
        },
        outputSchema: {
            type: 'object',
            properties: {
                visibleRecords: { type: 'array', items: { type: 'object' } }
            },
            required: ['visibleRecords']
        }
    },
    {
        name: 'undo',
        description: 'Rolls back the most recent change made through the component.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'redo',
        description: 'Reapplies the most recently undone change.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'excelExport',
        description: 'Exports the current Gantt content to an Excel-compatible output.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                exportProperties: { type: 'object' },
                isMultipleExport: { type: 'boolean' },
                workbook: { type: 'object' },
                isBlob: { type: 'boolean' }
            },
            required: ['exportProperties']
        },
        outputSchema: {
            type: 'object',
            properties: {
                exportResult: {}
            },
            required: ['exportResult']
        }
    },
    {
        name: 'pdfExport',
        description: 'Exports the current Gantt content to a PDF output.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                exportProperties: { type: 'object' },
                isMultipleExport: { type: 'boolean' },
                pdfDoc: { type: 'object' },
                isBlob: { type: 'boolean' }
            },
            required: []
        },
        outputSchema: {
            type: 'object',
            properties: {
                exportResult: {}
            },
            required: ['exportResult']
        }
    },
    {
        name: 'csvExport',
        description: 'Exports the current Gantt data to a CSV-compatible output.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                exportProperties: { type: 'object' },
                isMultipleExport: { type: 'boolean' },
                workbook: { type: 'object' },
                isBlob: { type: 'boolean' }
            },
            required: ['exportProperties']
        },
        outputSchema: {
            type: 'object',
            properties: {
                exportResult: {}
            },
            required: ['exportResult']
        }
    },
    {
        name: 'searchTasks',
        description: 'Searches for tasks based on a keyword across all task fields.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                keyword: { type: 'string' }
            },
            required: ['keyword']
        },
        outputSchema: {
            type: 'object',
            properties: {
                searchResults: { type: 'array', items: { type: 'object' } }
            },
            required: ['searchResults']
        }
    },
    {
        name: 'filterTasks',
        description: 'Filters tasks based on specified field criteria.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                fieldName: { type: 'string' },
                filterOperator: { type: 'string' },
                filterValue: {
                    anyOf: [
                        { type: 'string' },
                        { type: 'number' },
                        { type: 'boolean' },
                        { type: 'object' },
                        { type: 'array', items: { type: 'number' } },
                        { type: 'array', items: { type: 'string' } },
                        { type: 'array', items: { type: 'boolean' } },
                        { type: 'array', items: { type: 'object' } } // includes Date[] objects
                    ]
                }
            },
            required: ['fieldName', 'filterOperator', 'filterValue']
        },
        outputSchema: {
            type: 'object',
            properties: {
                filteredTasks: { type: 'array', items: { type: 'object' } }
            },
            required: ['filteredTasks']
        }
    },
    {
        name: 'sortTasks',
        description: 'Sorts tasks based on specified field and direction.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                columnName: { type: 'string' },
                direction: { type: 'string', enum: ['Ascending', 'Descending'] }
            },
            required: ['columnName', 'direction']
        },
        outputSchema: {
            type: 'object',
            properties: {
                sortedTasks: { type: 'array', items: { type: 'object' } }
            },
            required: ['sortedTasks']
        }
    },
    {
        name: 'indentTask',
        description: 'Indents a task to make it a child of the task above it.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] }
            },
            required: ['taskId']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'outdentTask',
        description: 'Outdents a task to make it a sibling of its parent task.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] }
            },
            required: ['taskId']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'getTaskById',
        description: 'Retrieves a specific task by its unique identifier.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] }
            },
            required: ['taskId']
        },
        outputSchema: {
            type: 'object',
            properties: {
                task: { type: 'object' }
            },
            required: ['task']
        }
    },
    {
        name: 'reorderColumns',
        description: 'Reorders columns in the Gantt grid view.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                fromFieldName: {
                    anyOf: [
                        { type: 'string' },
                        { type: 'array', items: { type: 'string' } }
                    ]
                },
                toFieldName: { type: 'string' }
            },
            required: ['fromFieldName', 'toFieldName']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'zoomTimeline',
        description: 'Adjusts the timeline zoom level to focus on different time periods.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                action: { type: 'string', enum: ['zoomIn', 'zoomOut', 'zoomToFit'] }
            },
            required: ['action']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'convertToMilestone',
        description: 'Converts a task to a milestone by removing its duration.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] }
            },
            required: ['taskId']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'mergeTask',
        description: 'Merges task segments into a single continuous task.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] },
                segmentIndexes: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            firstSegmentIndex: { type: 'number' },
                            secondSegmentIndex: { type: 'number' }
                        },
                        required: ['firstSegmentIndex', 'secondSegmentIndex']
                    }
                }
            },
            required: ['taskId', 'segmentIndexes']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'reorderRows',
        description: 'Reorders rows in the Gantt grid by moving tasks to different positions.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                fromIndexes: {
                    type: 'array',
                    items: { type: 'number' }
                },
                toIndex: { type: 'number' },
                position: { type: 'string' }
            },
            required: ['fromIndexes', 'toIndex', 'position']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'getRecordByID',
        description: 'Retrieves a specific record by its unique identifier.',
        annotations: { readOnlyHint: true },
        inputSchema: {
            type: 'object',
            properties: {
                recordId: { type: ['number', 'string'] }
            },
            required: ['recordId']
        },
        outputSchema: {
            type: 'object',
            properties: {
                record: { type: 'object' }
            },
            required: ['record']
        }
    },
    {
        name: 'getGanttColumns',
        description: 'Retrieves the current column configuration of the Gantt chart.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: {
            type: 'object',
            properties: {
                columns: { type: 'array', items: { type: 'object' } }
            },
            required: ['columns']
        }
    },
    {
        name: 'getGridColumns',
        description: 'Retrieves the current column configuration of the TreeGrid portion.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: {
            type: 'object',
            properties: {
                columns: { type: 'array', items: { type: 'object' } }
            },
            required: ['columns']
        }
    },
    {
        name: 'clearFiltering',
        description: 'Clears all applied filters from the Gantt chart.',
        annotations: { readOnlyHint: false },
        inputSchema: {},
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'clearSorting',
        description: 'Clears all applied sorting from the Gantt chart.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'getUndoActions',
        description: 'Retrieves the list of actions available for undo operations.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: {
            type: 'object',
            properties: {
                actions: { type: 'array', items: { type: 'object' } }
            },
            required: ['actions']
        }
    },
    {
        name: 'getRedoActions',
        description: 'Retrieves the list of actions available for redo operations.',
        annotations: { readOnlyHint: true },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: {
            type: 'object',
            properties: {
                actions: { type: 'array', items: { type: 'object' } }
            },
            required: ['actions']
        }
    },
    {
        name: 'clearUndoCollection',
        description: 'Clears the entire undo collection, removing all undo capabilities.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'clearRedoCollection',
        description: 'Clears the entire redo collection, removing all redo capabilities.',
        annotations: { readOnlyHint: false },
        inputSchema: { type: 'object', properties: {}, required: [] },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'scrollToTask',
        description: 'Scrolls the view to bring a specific task into view.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                taskId: { type: ['number', 'string'] }
            },
            required: ['taskId']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    },
    {
        name: 'scrollToDate',
        description: 'Scrolls the timeline view to bring a specific date into view.',
        annotations: { readOnlyHint: false },
        inputSchema: {
            type: 'object',
            properties: {
                date: { type: 'string' }
            },
            required: ['date']
        },
        outputSchema: { type: 'object', properties: {}, required: [] }
    }
];
var WebMcpGantt = /** @class */ (function () {
    function WebMcpGantt(parent) {
        this.webMcpAbortController = null;
        this.parent = parent;
        this.addEventListener();
    }
    WebMcpGantt.prototype.addEventListener = function () {
        this.parent.on(EVENT_GET_TOOLS, this.getTools, this);
        this.parent.on(EVENT_REGISTER_TOOLS, this.registerTools, this);
    };
    WebMcpGantt.prototype.removeEventListener = function () {
        if (!this.parent.isDestroyed) {
            this.parent.off(EVENT_GET_TOOLS, this.getTools);
            this.parent.off(EVENT_REGISTER_TOOLS, this.registerTools);
        }
    };
    WebMcpGantt.prototype.getTools = function (args) {
        var toolNames = args.toolNames;
        if (!isNullOrUndefined(toolNames) && toolNames.length !== 0) {
            args.tools = webMcpTools
                .filter(function (tool) { return toolNames.indexOf(tool.name) !== -1; })
                .map(function (tool) {
                var clonedTool = {};
                Object.assign(clonedTool, tool);
                return clonedTool;
            });
        }
        else {
            args.tools = webMcpTools.map(function (tool) {
                var clonedTool = {};
                Object.assign(clonedTool, tool);
                return clonedTool;
            });
        }
        return args.tools;
    };
    WebMcpGantt.prototype.registerTools = function (args) {
        var _this = this;
        var modelContext = document.modelContext;
        if (!modelContext || typeof modelContext.registerTool !== 'function') {
            return;
        }
        this.webMcpAbortController = new AbortController();
        var toolPrefix = (isNullOrUndefined(args.prefix) ? this.parent.element.id : args.prefix);
        var tools = args.tools && args.tools.length && typeof args.tools[0] === 'object'
            ? args.tools
            : this.getTools({ toolNames: args.tools });
        tools.forEach(function (tool) {
            tool.name = toolPrefix + "_" + tool.name;
            tool.execute = tool.execute || (function (toolArgs) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.executeHandler(tool.name, toolArgs || {})];
            }); }); });
            modelContext.registerTool(tool, {
                signal: _this.webMcpAbortController.signal,
                exposedTo: args.exposedTo
            });
        });
    };
    WebMcpGantt.prototype.executeHandler = function (command, args) {
        return __awaiter(this, void 0, void 0, function () {
            var baseCommand_1, toolDef, eventArgs, readOnlyHint, summary, approved, _a, action, id, index, taskId, splitDateRaw, splitDate, taskId, operation, predecessorString, startDate, endDate, isTimelineRoundOff, isFrom, records, record, exportProperties, workbook, record, exportProperties, pdfDoc, record, record, taskId, record, taskId, record, record, fromFieldName, toFieldName, action, taskId, segmentIndexes, fromIndexes, toIndex, position, record, record, record, fields, actions, record, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 46, , 47]);
                        baseCommand_1 = command.includes('_') ? command.substring(command.indexOf('_') + 1) : command;
                        toolDef = webMcpTools.find(function (t) { return t.name === baseCommand_1; });
                        eventArgs = { toolName: command, toolArgs: args };
                        this.parent.trigger(EVENT_BEFORE_EXECUTE, eventArgs);
                        if (eventArgs.cancel) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand_1,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse || "[USER_CANCELLED] Tool \"" + baseCommand_1 + "\" was cancelled. This is final. Do NOT retry."
                                })];
                        }
                        readOnlyHint = !!(toolDef && toolDef.annotations && toolDef.annotations.readOnlyHint);
                        if (!(!readOnlyHint && eventArgs.showConfirmationDialog)) return [3 /*break*/, 2];
                        summary = this.buildConfirmationMessage(baseCommand_1, args);
                        return [4 /*yield*/, this.requestConfirmation(baseCommand_1, args, summary)];
                    case 1:
                        approved = _b.sent();
                        if (!approved) {
                            return [2 /*return*/, this.message({
                                    action: baseCommand_1,
                                    cancelled: true,
                                    message: eventArgs.cancellationResponse || "[USER_CANCELLED] User denied: \"" + summary + "\". This is final. Do NOT retry."
                                })];
                        }
                        _b.label = 2;
                    case 2:
                        _a = baseCommand_1;
                        switch (_a) {
                            case 'getProjectTasks': return [3 /*break*/, 3];
                            case 'getTaskDetails': return [3 /*break*/, 4];
                            case 'manageHierarchy': return [3 /*break*/, 5];
                            case 'getCriticalTasks': return [3 /*break*/, 6];
                            case 'createTask': return [3 /*break*/, 7];
                            case 'updateTask': return [3 /*break*/, 8];
                            case 'deleteTask': return [3 /*break*/, 9];
                            case 'splitTask': return [3 /*break*/, 10];
                            case 'manageTaskDependencies': return [3 /*break*/, 11];
                            case 'updateProjectDates': return [3 /*break*/, 12];
                            case 'getVisibleTasksHierarchy': return [3 /*break*/, 13];
                            case 'undo': return [3 /*break*/, 14];
                            case 'redo': return [3 /*break*/, 15];
                            case 'excelExport': return [3 /*break*/, 16];
                            case 'pdfExport': return [3 /*break*/, 18];
                            case 'csvExport': return [3 /*break*/, 20];
                            case 'searchTasks': return [3 /*break*/, 22];
                            case 'filterTasks': return [3 /*break*/, 23];
                            case 'sortTasks': return [3 /*break*/, 24];
                            case 'indentTask': return [3 /*break*/, 25];
                            case 'outdentTask': return [3 /*break*/, 26];
                            case 'getTaskById': return [3 /*break*/, 27];
                            case 'reorderColumns': return [3 /*break*/, 28];
                            case 'zoomTimeline': return [3 /*break*/, 29];
                            case 'convertToMilestone': return [3 /*break*/, 30];
                            case 'mergeTask': return [3 /*break*/, 31];
                            case 'reorderRows': return [3 /*break*/, 32];
                            case 'getRecordByID': return [3 /*break*/, 33];
                            case 'getGanttColumns': return [3 /*break*/, 34];
                            case 'getGridColumns': return [3 /*break*/, 35];
                            case 'clearFiltering': return [3 /*break*/, 36];
                            case 'clearSorting': return [3 /*break*/, 37];
                            case 'getUndoActions': return [3 /*break*/, 38];
                            case 'getRedoActions': return [3 /*break*/, 39];
                            case 'clearUndoCollection': return [3 /*break*/, 40];
                            case 'clearRedoCollection': return [3 /*break*/, 41];
                            case 'scrollToTask': return [3 /*break*/, 42];
                            case 'scrollToDate': return [3 /*break*/, 43];
                        }
                        return [3 /*break*/, 44];
                    case 3: return [2 /*return*/, this.message({ record: this.parent.getCurrentViewData() })];
                    case 4: return [2 /*return*/, this.message({ record: this.parent.getTaskInfo(args.taskId) })];
                    case 5:
                        {
                            action = args.action;
                            id = args.id;
                            index = args.index;
                            switch (action) {
                                case 'expandAll':
                                    this.parent.expandAll();
                                    break;
                                case 'collapseAll':
                                    this.parent.collapseAll();
                                    break;
                                case 'expandByID':
                                    this.parent.expandByID(id);
                                    break;
                                case 'expandByIndex':
                                    this.parent.expandByIndex(index);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown hierarchy action: \"" + action + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 6;
                    case 6: return [2 /*return*/, this.message({ record: this.parent.getCriticalTasks() })];
                    case 7:
                        this.parent.addRecord(args.data, args.rowPosition, args.rowIndex);
                        return [2 /*return*/, this.message({})];
                    case 8:
                        this.parent.updateRecordByID(args.data);
                        return [2 /*return*/, this.message({})];
                    case 9:
                        this.parent.deleteRecord(args.taskDetail);
                        return [2 /*return*/, this.message({})];
                    case 10:
                        {
                            taskId = args.taskId;
                            splitDateRaw = args.splitDate;
                            splitDate = Array.isArray(splitDateRaw)
                                ? (splitDateRaw).map(function (d) { return new Date(d); })
                                : new Date(splitDateRaw);
                            this.parent.splitTask(taskId, splitDate);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 11;
                    case 11:
                        {
                            taskId = args.taskId;
                            operation = args.operation;
                            predecessorString = args.predecessorString;
                            switch (operation) {
                                case 'add':
                                    this.parent.addPredecessor(taskId, predecessorString);
                                    break;
                                case 'update':
                                    this.parent.updatePredecessor(taskId, predecessorString);
                                    break;
                                case 'remove':
                                    this.parent.removePredecessor(taskId);
                                    break;
                                default:
                                    return [2 /*return*/, this.error("Unknown dependency operation: \"" + operation + "\"")];
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 12;
                    case 12:
                        {
                            startDate = new Date(args.startDate);
                            endDate = new Date(args.endDate);
                            isTimelineRoundOff = args.isTimelineRoundOff;
                            isFrom = args.isFrom;
                            this.parent.updateProjectDates(startDate, endDate, isTimelineRoundOff, isFrom);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 13;
                    case 13:
                        {
                            records = args.records || this.parent.getCurrentViewData();
                            record = this.parent.getExpandedRecords(records);
                            return [2 /*return*/, this.message({ record: record })];
                        }
                        _b.label = 14;
                    case 14:
                        this.parent.undo();
                        return [2 /*return*/, this.message({})];
                    case 15:
                        this.parent.redo();
                        return [2 /*return*/, this.message({})];
                    case 16:
                        exportProperties = args.exportProperties && typeof args.exportProperties === 'object' && !Array.isArray(args.exportProperties)
                            ? Object.keys(args.exportProperties).length
                                ? args.exportProperties
                                : null
                            : args.exportProperties;
                        workbook = args.workbook && typeof args.workbook === 'object' && !Array.isArray(args.workbook)
                            /* eslint-disable-next-line */
                            ? Object.keys(args.workbook).length ? args.workbook : null : args.workbook;
                        return [4 /*yield*/, this.parent.excelExport(exportProperties, args.isMultipleExport, workbook, args.isBlob)];
                    case 17:
                        record = _b.sent();
                        return [2 /*return*/, this.message({ record: record })];
                    case 18:
                        exportProperties = args.exportProperties && typeof args.exportProperties === 'object' && !Array.isArray(args.exportProperties)
                            ? Object.keys(args.exportProperties).length
                                ? args.exportProperties
                                : null
                            : args.exportProperties;
                        pdfDoc = args.pdfDoc && typeof args.pdfDoc === 'object' && !Array.isArray(args.pdfDoc)
                            ? Object.keys(args.pdfDoc).length
                                ? args.pdfDoc
                                : null
                            : args.pdfDoc;
                        return [4 /*yield*/, this.parent.pdfExport(exportProperties, args.isMultipleExport, pdfDoc, args.isBlob)];
                    case 19:
                        record = _b.sent();
                        return [2 /*return*/, this.message({ record: record })];
                    case 20: return [4 /*yield*/, this.parent.csvExport(args.exportProperties, args.isMultipleExport, 
                        /* eslint-disable-next-line */
                        args.workbook, args.isBlob)];
                    case 21:
                        record = _b.sent();
                        return [2 /*return*/, this.message({ record: record })];
                    case 22:
                        {
                            this.parent.search(args.keyword);
                            // Note: search doesn't return results directly, would need to get current view data
                            return [2 /*return*/, this.message({ record: this.parent.getCurrentViewData() })];
                        }
                        _b.label = 23;
                    case 23:
                        {
                            this.parent.filterByColumn(args.fieldName, args.filterOperator, args.filterValue);
                            return [2 /*return*/, this.message({ record: this.parent.getCurrentViewData() })];
                        }
                        _b.label = 24;
                    case 24:
                        {
                            this.parent.sortColumn(args.columnName, args.direction);
                            return [2 /*return*/, this.message({ record: this.parent.getCurrentViewData() })];
                        }
                        _b.label = 25;
                    case 25:
                        {
                            taskId = args.taskId;
                            record = this.parent.getRecordByID(taskId);
                            if (record) {
                                this.parent.selectRow(record.index);
                                this.parent.indent();
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 26;
                    case 26:
                        {
                            taskId = args.taskId;
                            record = this.parent.getRecordByID(taskId);
                            if (record) {
                                this.parent.selectRow(record.index);
                                this.parent.outdent();
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 27;
                    case 27:
                        {
                            record = this.parent.getTaskInfo(args.taskId);
                            return [2 /*return*/, this.message({ record: record })];
                        }
                        _b.label = 28;
                    case 28:
                        {
                            fromFieldName = args.fromFieldName;
                            toFieldName = args.toFieldName;
                            if (Array.isArray(fromFieldName)) {
                                this.parent.reorderColumns(fromFieldName, toFieldName);
                            }
                            else {
                                this.parent.reorderColumns(fromFieldName, toFieldName);
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 29;
                    case 29:
                        {
                            action = args.action;
                            switch (action) {
                                case 'zoomIn':
                                    this.parent.zoomIn();
                                    break;
                                case 'zoomOut':
                                    this.parent.zoomOut();
                                    break;
                                case 'zoomToFit':
                                    this.parent.fitToProject();
                                    break;
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 30;
                    case 30:
                        {
                            this.parent.convertToMilestone(args.taskId);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 31;
                    case 31:
                        {
                            taskId = args.taskId;
                            segmentIndexes = args.segmentIndexes;
                            if (Array.isArray(segmentIndexes) && segmentIndexes.length) {
                                this.parent.mergeTask(taskId, segmentIndexes);
                            }
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 32;
                    case 32:
                        {
                            fromIndexes = args.fromIndexes;
                            toIndex = args.toIndex;
                            position = args.position;
                            this.parent.reorderRows(fromIndexes, toIndex, position);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 33;
                    case 33:
                        {
                            record = this.parent.getRecordByID(args.recordId);
                            return [2 /*return*/, this.message({ record: record })];
                        }
                        _b.label = 34;
                    case 34:
                        {
                            record = this.parent.getGanttColumns();
                            return [2 /*return*/, this.message({ record: record })];
                        }
                        _b.label = 35;
                    case 35:
                        {
                            record = this.parent.getGridColumns();
                            return [2 /*return*/, this.message({ record: record })];
                        }
                        _b.label = 36;
                    case 36:
                        {
                            fields = args.fields;
                            this.parent.clearFiltering(fields);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 37;
                    case 37:
                        {
                            this.parent.clearSorting();
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 38;
                    case 38:
                        {
                            actions = this.parent.getUndoActions();
                            return [2 /*return*/, this.message({ actions: actions })];
                        }
                        _b.label = 39;
                    case 39:
                        {
                            record = this.parent.getRedoActions();
                            return [2 /*return*/, this.message({ record: record })];
                        }
                        _b.label = 40;
                    case 40:
                        {
                            this.parent.clearUndoCollection();
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 41;
                    case 41:
                        {
                            this.parent.clearRedoCollection();
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 42;
                    case 42:
                        {
                            this.parent.scrollToTask(args.taskId);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 43;
                    case 43:
                        {
                            this.parent.scrollToDate(args.date);
                            return [2 /*return*/, this.message({})];
                        }
                        _b.label = 44;
                    case 44: return [2 /*return*/, this.error("Tool \"" + baseCommand_1 + "\" not found.")];
                    case 45: return [3 /*break*/, 47];
                    case 46:
                        e_1 = _b.sent();
                        return [2 /*return*/, this.error(e_1.message ? String(e_1.message) : 'Tool execution failed')];
                    case 47: return [2 /*return*/];
                }
            });
        });
    };
    WebMcpGantt.prototype.buildConfirmationMessage = function (command, args) {
        return "Confirm: " + command + " with args: " + JSON.stringify(args || {});
    };
    WebMcpGantt.prototype.requestConfirmation = function (_command, _args, _message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // No UI integration in this repo; assume approval.
                return [2 /*return*/, true];
            });
        });
    };
    WebMcpGantt.prototype.message = function (data) {
        return {
            content: [{
                    type: 'text', text: JSON.stringify({
                        records: data.record
                    })
                }]
        };
    };
    WebMcpGantt.prototype.error = function (text) {
        return { content: [{ type: 'text', text: text }], isError: true };
    };
    WebMcpGantt.prototype.destroy = function () {
        this.removeEventListener();
        if (this.webMcpAbortController) {
            this.webMcpAbortController.abort();
            this.webMcpAbortController = null;
        }
        this.parent = null;
    };
    WebMcpGantt.prototype.getModuleName = function () {
        return 'webMcpGantt';
    };
    return WebMcpGantt;
}());
export { WebMcpGantt };
